import { StyleSheet } from 'aphrodite';
import { darkGrayFontColor } from '../../styles/colors';

export const styleSheet = StyleSheet.create({
	sendFromDropdownContainer: {
		alignItems: 'center',
		color: darkGrayFontColor,
		display: 'flex',
		fontSize: 14,
		width: '100%',
	},
	sendFromUserSelectBox: {
		maxWidth: '55%',
	},
});
